import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M24.044 26.694 10.438 40.257a.957.957 0 0 1-1.36 0l-1.355-1.359a.957.957 0 0 1 0-1.356L21.33 23.979 7.755 10.464a.956.956 0 0 1 0-1.356l1.359-1.359a.957.957 0 0 1 1.355 0l13.575 13.515L37.566 7.743a.96.96 0 0 1 1.36 0l1.356 1.359a.956.956 0 0 1 0 1.356L26.76 23.979l13.5 13.563a.956.956 0 0 1 0 1.356l-1.36 1.359a.955.955 0 0 1-1.355 0l-13.5-13.563Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function c(r, d) {
  return e(), l("svg", t, a);
}
const i = { render: c };
export {
  i as default,
  c as render
};
//# sourceMappingURL=close.svg.mjs.map
